import type { AdminPublic } from '@cookspace-shared-contracts/core';
import { createSlice } from '@reduxjs/toolkit';

import { authApi } from '@/api/authApi';
import type { RootState } from '@/store';

interface AuthState {
    admin: AdminPublic | null;
    /** true до завершения первого me-запроса при старте приложения. */
    isLoading: boolean;
    isAuthenticated: boolean;
}

const initialState: AuthState = {
    admin: null,
    isLoading: true,
    isAuthenticated: false
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        logout(state) {
            state.admin = null;
            state.isAuthenticated = false;
            state.isLoading = false;
        }
    },
    extraReducers: (builder) => {
        builder
            .addMatcher(authApi.endpoints.me.matchFulfilled, (state, action) => {
                state.admin = action.payload.admin;
                state.isAuthenticated = true;
                state.isLoading = false;
            })
            .addMatcher(authApi.endpoints.me.matchRejected, (state) => {
                state.admin = null;
                state.isAuthenticated = false;
                state.isLoading = false;
            })
            .addMatcher(
                authApi.endpoints.login.matchFulfilled,
                (state, action) => {
                    if (action.payload.status === 'success') {
                        state.admin = action.payload.admin;
                        state.isAuthenticated = true;
                        state.isLoading = false;
                    }
                }
            )
            .addMatcher(
                authApi.endpoints.twofaVerify.matchFulfilled,
                (state, action) => {
                    state.admin = action.payload.admin;
                    state.isAuthenticated = true;
                    state.isLoading = false;
                }
            )
            .addMatcher(authApi.endpoints.logout.matchFulfilled, (state) => {
                state.admin = null;
                state.isAuthenticated = false;
                state.isLoading = false;
            });
    }
});

export const { logout } = authSlice.actions;

export const selectAdmin = (state: RootState): AdminPublic | null => state.auth.admin;
export const selectIsAuthenticated = (state: RootState): boolean =>
    state.auth.isAuthenticated;
export const selectIsAuthLoading = (state: RootState): boolean => state.auth.isLoading;

export default authSlice.reducer;
